module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "p_heading_",
    attrs: {
      "id": "auto_bookmark_toc_1"
    }
  }, [_c('span', [_vm._v("Day und Knight")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "p_norm-noindent"
  }, [_vm._v("Von Dirk Greyson")]), _vm._v(" "), _c('p', {
    staticClass: "p_norm-noindent"
  }, [_vm._v("Buch 1 in der Serie – Day und Knight")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Als ehemaliger NSA-Mitarbeiter hat Dayton (Day) Ingram Erfahrungen als Hacker im Dienst der nationalen Sicherheit und arbeitet jetzt als technischer Analyst für Scorpion. Er sehnt sich nach dem Außendienst, und als er einen Angriff vereitelt, bekommt er seine Chance. Er ist clever, mehrsprachig und ein Technologiemagier. Aber seine Chance hat einen Haken – einen Partner, Knighton (Knight), der ein echtes Rätsel ist. Trotz zahlloser Recherchestunden kann Day nichts über den Agenten finden, nicht einmal seinen Vornamen!")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Der ehemalige Marine Knight hatte sich nach dem Verlust seiner Familie am Boden einer Flasche verkrochen. Nachdem er wieder trocken ist, bekommt er eine allerletzte Chance: zusammen mit Day eine terroristische Bedrohung aus Yucatàn auszuschalten. Um ohne Aufsehen zu erregen dorthin zu gelangen, machen Day und Knight eine Kreuzfahrt für Schwule mit, wo der, wenn es um seine sexuelle Orientierung geht, zutiefst verschwiegene Day und ein ebenso verschwiegener Knight als schwules Paar agieren müssen. Die Anspannung wächst, als Knight sich ausschweigt und Day sich gegen Knights unbarmherziges Verlangen nach Kontrolle sträubt.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Aber nach einer durchzechten Nacht, wachen Day und Knight in einem Bett auf. Zusammen. Während sie ihrem Ziel näherkommen, müssen sie lernen, einander zu vertrauen und sich aufeinander zu verlassen. Nur so können sie das Terroristencamp infiltrieren und das Komplott gegen die technologische Infrastruktur der USA vereiteln. Nur dann können sie auf ein Leben nach der Mission hoffen.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Ein gemeinsames Leben.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-98d33330","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OPS/section0002.vue
// module id = 60
// module chunks = 0